import React from 'react';

export const Settings: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.27281 6.72722C9.97576 7.43017 9.97576 8.56986 9.27281 9.27281C8.56986 9.97576 7.43017 9.97576 6.72722 9.27281C6.02428 8.56986 6.02428 7.43017 6.72722 6.72722C7.43017 6.02428 8.56986 6.02428 9.27281 6.72722"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.49999 8C3.49999 8.198 3.51799 8.396 3.54199 8.588L2.48333 9.416C2.24866 9.6 2.18466 9.92867 2.33399 10.1867L3.27533 11.8153C3.42399 12.0733 3.73999 12.182 4.01666 12.0713L4.96466 11.6907C5.152 11.6153 5.36066 11.6453 5.52866 11.7567C5.67533 11.854 5.82733 11.9433 5.98466 12.0233C6.16466 12.1147 6.29533 12.278 6.324 12.478L6.46866 13.4867C6.51066 13.7813 6.76333 14 7.06066 14H8.93866C9.236 14 9.48866 13.7813 9.53066 13.4867L9.67533 12.4787C9.70399 12.2787 9.83599 12.114 10.0167 12.0233C10.1733 11.9447 10.3247 11.856 10.4707 11.7593C10.64 11.6473 10.8493 11.6153 11.0373 11.6913L11.9833 12.0713C12.2593 12.182 12.5753 12.0733 12.7247 11.8153L13.666 10.1867C13.8153 9.92867 13.7513 9.59933 13.5167 9.416L12.458 8.588C12.482 8.396 12.5 8.198 12.5 8C12.5 7.802 12.482 7.604 12.458 7.412L13.5167 6.584C13.7513 6.4 13.8153 6.07133 13.666 5.81333L12.7247 4.18467C12.576 3.92667 12.26 3.818 11.9833 3.92867L11.0373 4.30867C10.8493 4.384 10.64 4.35267 10.4707 4.24067C10.3247 4.144 10.1733 4.05533 10.0167 3.97667C9.83599 3.886 9.70399 3.72133 9.67533 3.52133L9.53133 2.51333C9.48933 2.21867 9.23666 2 8.93933 2H7.06133C6.764 2 6.51133 2.21867 6.46933 2.51333L6.324 3.52267C6.29533 3.722 6.16399 3.886 5.98466 3.97733C5.82733 4.05733 5.67533 4.14733 5.52866 4.244C5.35999 4.35467 5.15133 4.38467 4.96399 4.30933L4.01666 3.92867C3.73999 3.818 3.42399 3.92667 3.27533 4.18467L2.33399 5.81333C2.18466 6.07133 2.24866 6.40067 2.48333 6.584L3.54199 7.412C3.51799 7.604 3.49999 7.802 3.49999 8V8Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
